import styled from "@emotion/styled";
import { Theme } from "../../../../styles/theme";

export interface SymbolSelectorProps {
  theme: Theme;
}

export const SymbolSelector = styled.div<SymbolSelectorProps>`
  font-weight: 400;
  font-size: 22px;
`;
